/**
 * Glossary search/filter bar — extracted from AdminGlossaryTab.
 * Pure presentation component; lifts no state.
 */
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import { Search, Filter, RefreshCw } from 'lucide-react';

const GlossaryFilters = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  categories,
  loading,
  onRefresh,
}) => (
  <div className="flex gap-4 mb-4">
    <div className="flex-1 relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
      <Input
        placeholder="Begriff, Definition oder Tags suchen..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
        data-testid="search-input"
      />
    </div>
    <Select
      value={selectedCategory || 'all'}
      onValueChange={(val) => onCategoryChange(val === 'all' ? '' : val)}
    >
      <SelectTrigger className="w-48" data-testid="category-filter">
        <Filter className="w-4 h-4 mr-2" />
        <SelectValue placeholder="Alle Kategorien" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Alle Kategorien</SelectItem>
        {categories.map((cat) => (
          <SelectItem key={cat} value={cat}>{cat}</SelectItem>
        ))}
      </SelectContent>
    </Select>
    <Button variant="ghost" size="icon" onClick={onRefresh} data-testid="refresh-btn">
      <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
    </Button>
  </div>
);

export default GlossaryFilters;
